export const IS_IN_DEV_MODE = localStorage.mode === 'development';
